import SLIDER from '../class/slider'
import GET_ARTICLES from '../plugins/getArticles'
import imageMapResize from 'image-map-resizer'

const [ w, d, mq ] = [ window, document, window.matchMedia( "(max-width: 900px)" ) ];

const slider = new SLIDER ({
  obj: '[data-plugin="slider"]',
  animationDuration: 8000,
  slickOpt: {
    autoplay: true,
    fade: true,
    dots: true,
    speed: 2000,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    pauseOnFocus: false,
    arrows: false
  }
});

const tagList = tags => {
  const $tags = $('<div class="tags"></div>');

  tags.forEach( tag => {
    const $tag = $('<span class="tag"/>');
    $tag.text( '#' + tag ).appendTo( $tags );
  });
  return $tags[0].outerHTML;
};

const init = () => {

  $.when( w.load['mainvisual'] ).then(() => {
    slider.init(), slider.start();
    //スマホでタップ時にautoplayが止まる現象の対策
    $('.mainvisual__slider').on('touchend', () => slider.start() );

    //キャッチ クラス付与
    setTimeout(() => {
      $('.mainvisual__catch').addClass('is-start');
    }, 1000);

    // ticker
    let makeItem = item => $(`
      <a href="${item.href}" class="link">
        <span class="date">${item.date}</span>
        <span class="cat">【${item.category.name}】</span>
        <h3 class="subject">${item.title}</h3>
      </a>
    `)[0];
    GET_ARTICLES( '.block-ticker__article[data-plugin="getArticles"]', { makeItem });
  });

  //production
  $.when(w.load['block-production']).then( () => {
    imageMapResize();
  });

  // works
  $.when(w.load['block-works']).then( () => {
    let makeItem = item => $(`
      <li class="block-works-item">
        <a href="${item.href}" class="block-works-item__link">
          <figure class="block-works-item__img">
            <div class="block-works-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="200" loading="lazy"></div>
          </figure>
          <div class="block-works-item__body">
            <h3 class="subject">${item.title.str_truncate(24)}</h3>
            ${item.keywords ? tagList(item.keywords) : ''}
          </div>
        </a>
      </li>
    `)[0]
    GET_ARTICLES('.block-works__list[data-plugin="getArticles"]', { makeItem })
  })

  // news
  $.when( w.load['block-news'] ).then( () => {
    let makeItem = item => $(`
      <a class="block-news-item" href="${item.href}">
        <div class="date-cate">
          <span class="date">${item.date}</span>
          <span class="cate">${item.category.name}</span>
        </div>
        <div class="subjectWrap">
          <h3 class="subject ${item.is_new ? 'is-new': ''}">${item.title}</h3>
          ${item.is_new ? '<span class="is-new hidden-xsmall">NEW</span>': ''}
        </div>
      </a>
    `)[0]
    GET_ARTICLES('.block-news__list[data-plugin="getArticles"]', { makeItem })
  });

}

export default function HOME() {
  $( init )
}